import React from "react";

type DragProps = {
  children?: any;
  key: string | number;
  id: string;
  dispatch: React.Dispatch<{ type: string; payload?: any }>;
};

export default function DragComponent(props: DragProps) {
  const handleDragStart = (e: React.DragEvent<HTMLDivElement>) => {
    e.dataTransfer.setData("superset", e.currentTarget.id);
    e.dataTransfer.dropEffect = "move";
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const supersetId = parseInt(e.dataTransfer.getData("superset").replace("superset-", ""));
    const targetId = parseInt(e.currentTarget.id.replace("superset-", ""));
    const draggedSuperset = document.getElementById(`superset-${supersetId}`);
    const currentChild = e.currentTarget.firstChild;
    if (!draggedSuperset || !currentChild) return;
    // TODO dispatch updated order to parent component.
    props.dispatch({
      type: "reorder",
      payload: { supersetId, targetId },
    });
  };

  return (
    <div
      id={props.id}
      className="drag"
      style={{ margin: 0, padding: 0 }}
      draggable
      onDragOver={handleDragOver}
      onDragStart={handleDragStart}
      onDrop={handleDrop}
    >
      {props.children}
    </div>
  );
}
